import { connect } from 'react-redux';
import React, { Component } from 'react';

import { navigate } from 'libs/router';

import { equals, isRequired, isValidPassword } from 'utils/validators';
import { submitReset } from '../reducers/passwordReset';
import ActionButton from 'components/buttons/action-button/ActionButton';
import Form from 'components/form/Form';
import FormField from 'components/form/form-field/FormField';
import Input from 'components/inputs/input/Input';
import TermsAndConditions from './TermsAndConditions';
import { t } from 'utils/language';

import '../common/access-form.scss';
import '../common/access-actions.scss';

import type { LocationWindow } from 'types';

type Props = {
  dispatch: any,
  location: LocationWindow,
  params: Record<string, string>,
  showTermsAndConditions?: boolean,
  resetButtonLabel: string
};

type State = {
  password1: string,
  password2: string
}

class PasswordResetForm extends Component<Props, State> {
  state = {
    password1: '',
    password2: ''
  };

  handleChange = (event) => {
    const input = event.target;
    this.setState<never>({
      [input.name]: input.value
    });
  };

  handleSubmit = () => {
    const { location } = this.props;
    const { id } = this.props.params;
    const action = location.query.action || 'reset';

    this.props.dispatch(
      submitReset({
        password: this.state.password1,
        token: location.query.token,
        id
      })
    )
      .then(() => navigate.to(`/users/${id}/password/notification?action=${action}`));
  };

  render() {
    const { showTermsAndConditions } = this.props;
    const { password1, password2 } = this.state;

    return (
      <Form
        className="access-form"
        data={{ qa: 'access-form' }}
        onSubmit={this.handleSubmit}
      >
        <FormField
          label={t('signup_password')}
          helpNote={t('password_should_be_strong_comment')}
          validators={[
            isRequired(this.state.password1),
            isValidPassword(this.state.password1)
          ]}
        >
          <Input
            name="password1"
            type="password"
            autoFocus
            value={password1}
            onChange={this.handleChange}
          />
        </FormField>
        <FormField
          label={t('signup_confirm_password')}
          validators={[
            isRequired(password2),
            equals(password1, password2, t('password_does_not_match'))
          ]}
        >
          <Input
            name="password2"
            value={password2}
            onChange={this.handleChange}
            type="password"
          />
        </FormField>

        <div className="access-actions__secondary">
          {
            showTermsAndConditions &&
              <TermsAndConditions buttonLabel={this.props.resetButtonLabel} />
          }
        </div>

        <div className="access-actions">
          <ActionButton
            color="tertiary"
            link="/login"
            data-qa="access-form__button"
          >
            {t('action_button_cancel')}
          </ActionButton>
          <ActionButton
            type="submit"
            data-qa="access-form__button"
          >
            {this.props.resetButtonLabel}
          </ActionButton>
        </div>

      </Form>
    );
  }
}

export default connect()(PasswordResetForm);
